import api from "./api.js";
import CONFIG from "../config/config.js";

if (typeof window !== "undefined") {
  window.PromptoAPI = api;
  window.PromptoRuntime = createRuntimeDiagnostics(CONFIG);
  if (!CONFIG.USE_MOCK) {
    console.info("[Promzi] real backend mode", { apiBaseUrl: CONFIG.API_BASE_URL });
  }
}

function createRuntimeDiagnostics(config) {
  return {
    mode: config.USE_MOCK ? "mock" : "real",
    useMock: config.USE_MOCK,
    apiBaseUrl: config.API_BASE_URL,
    debug: Boolean(config.DEBUG),
    requests: [],
    lastError: null,
    recordRequest(entry) {
      const item = {
        at: new Date().toISOString(),
        method: entry.method,
        path: entry.path,
        ok: Boolean(entry.ok),
        status: entry.status || 0,
        code: entry.code || null,
        message: entry.message || null,
      };
      this.requests.push(item);
      if (this.requests.length > 30) this.requests.shift();
      if (!item.ok) this.lastError = item;
      if (this.debug || (!this.useMock && !item.ok)) {
        const level = item.ok ? "debug" : "warn";
        console[level]("[Promzi API]", item);
      }
    },
  };
}

export default api;
